export enum EntityViewType {
  SupplierView = 'supplier-view',
  AccountView = 'account-view'
}
